export default "__VITE_ASSET__DAqzUerv__"